
export default {
  default() {
    return {}
  },

  forCreate(data) {
    return {
      ...data
    };
  },

  forUpdate(data) {
    return {
      ...data
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/position/position-model.js